import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Acceptance, getTenantAcceptances, MissingTenant } from "../../service/LegalService";
import { StyledTableCell, StyledTableRow, TableWrapper } from "../logs/logStyles";

// On a tenant: which versions of the terms and the data processing agreement they accepted - when, by whom, from where
export default function TenantAgreements({ tenantId }: { tenantId: string }) {
  const [t] = useTranslation("global");
  const [data, setData] = useState<{ missing: MissingTenant["missing"]; acceptances: Acceptance[] } | null>(null);

  useEffect(() => {
    if (tenantId) getTenantAcceptances(tenantId).then(setData);
  }, [tenantId]);

  if (!data) return null;
  return (
    <Box sx={{ marginBottom: "2%" }}>
      <Typography variant="h6" sx={{ width: "100%", mt: 2 }}>
        {t("legal.tenantTitle")}
      </Typography>
      {data.missing.length > 0 && (
        <Typography variant="body2" color="error.main" sx={{ width: "100%" }}>
          {t("legal.missing")}: {data.missing.map((doc) => `${doc.title} v${doc.version}`).join(", ")}
        </Typography>
      )}
      <TableWrapper component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell>{t("legal.document")}</StyledTableCell>
              <StyledTableCell>{t("legal.version")}</StyledTableCell>
              <StyledTableCell>{t("legal.acceptedAt")}</StyledTableCell>
              <StyledTableCell>{t("legal.company")}</StyledTableCell>
              <StyledTableCell>{t("legal.ipBrowser")}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.acceptances.map((row, index) => (
              <StyledTableRow key={`${row.type}-${row.version}-${index}`}>
                <TableCell>{t(`legal.types.${row.type}`)}</TableCell>
                <TableCell>{row.version}</TableCell>
                <TableCell>{new Date(row.acceptedAt).toLocaleString("da-DK")}</TableCell>
                <TableCell>
                  {row.companyName}
                  {row.cvr ? ` (CVR ${row.cvr})` : ""}
                </TableCell>
                <TableCell sx={{ fontSize: 12 }}>
                  {row.ip} · {row.userAgent.slice(0, 60)}
                </TableCell>
              </StyledTableRow>
            ))}
            {!data.acceptances.length && (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                  {t("legal.noAcceptances")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableWrapper>
    </Box>
  );
}
